#import "../../../../core/select/fragments/activity-type-fragment.graphql"

mutation UpdateActivityType($input: ActivityTypeUpdateInput!) {
    activityTypeUpdate(input: $input) {
        activityType {
            ...ActivityType
        }
    }
}
